import API from "../api";

export const getStates = () => {
    return API.get(`dictionary/get-states`);
};
